import request from '@/utils/request'

export function pageChapters(pageNum, pageSize, courseId, title) {
  return request({
    url: '/amc/course-chapter/paging',
    method: 'get',
    params: { pageNum, pageSize, courseId, title }
  })
}

export function pageNewChapters(pageNum, pageSize, courseId) {
  return request({
    url: '/amc/course-chapter/new',
    method: 'get',
    params: { pageNum, pageSize, courseId }
  })
}

// 查询所有章节（不分页）
export function listChapters(courseId, title) {
  return request({
    url: '/amc/course-chapter/list',
    method: 'get',
    params: title ? { courseId, title } : { courseId }
  })
}

export function createChapter(data) {
  return request({
    url: '/amc/course-chapter',
    method: 'post',
    data
  })
}

export function updateChapter(id, data) {
  return request({
    url: `/amc/course-chapter/${id}`,
    method: 'put',
    data
  })
}

export function deleteChapter(id) {
  return request({
    url: `/amc/course-chapter/${id}`,
    method: 'delete'
  })
}
